import Swiper, { EffectCreative, Navigation } from 'swiper';

class HomeHero {
  constructor(el) {
    this.el = el;
    Swiper.use([EffectCreative, Navigation]);

    this.initSlider();
  }
  initSlider() {
    this.swiper = new Swiper(this.el.querySelector('.swiper'), {
      effect: 'creative',
      creativeEffect: {
        limitProgress: 5,
        prev: {
          translate: ['-12.5%', 0, -136],
          opacity: 0.6,
          rotate: [0, 0, 0],
        },
        next: {
          translate: ['12.5%', 0, -136],
          opacity: 0.6,
          rotate: [0, 0, 0],
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 4000,
      },
    });
  }
}

export default HomeHero;
